import { Box as MuiBox, withStyles } from '@material-ui/core';

import { COLORS } from 'theme/constants';
import { drawerWidth } from 'layouts/Dashboard/constants';

export const BoxContainer = withStyles({
  root: {
    '& .MuiSnackbar-root': {
      position: 'absolute',
      top: '24px',
      bottom: 'auto',
      left: 'auto',
      right: `calc(50% - ${drawerWidth}px)`,
      minWidth: '30%',
      transform: 'none',
    },
    '& .MuiPaper-root': {
      width: '100%',
      background: COLORS.white,
      color: COLORS.alertText,
      boxShadow: '0 3px 3px 1px rgba(0, 0, 0, 0.14);',
    },
    '& .MuiPaper-root .MuiAlert-icon': {
      color: COLORS.cozmosRed,
      marginRight: '6px',
    },
    '& .MuiAlert-action': {
      alignItems: 'flex-start',
    },
  },
})(MuiBox);
